import React from "react";
import { Box, Grid, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { customSelectStyles } from "./input-fields/selectStyles";
import "./input-fields/styles.css";

const PageHeader = ({
  title,
  description,
  selectOptions,
  onSelectChange,
  actionButton,
}) => {
  const navigate = useNavigate();

  const handleSelectChange = (option) => {
    if (option?.navigateTo) {
      navigate(option.navigateTo);
    }
    if (onSelectChange) {
      onSelectChange(option);
    }
  };

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      mb={2}
      wrap="nowrap"
    >
      {/* Left side (Back button + Title/Description) */}
      <Grid item mb={1} sx={{ flex: 1, minWidth: 0 }}>
        <Box display="flex" alignItems="flex-start" sx={{ minWidth: 0 }}>
          <IconButton
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: "transparent",
              color: "#1F61C5",
              width: 32,
              height: 32,
              mr: 1,
              mt: 1,
              "&:hover": {
                backgroundColor: "#1F61C5",
                color: "#fff",
              },
            }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Box sx={{ minWidth: 0 }}>
            <div
              className="dashboard-header"
              style={{ overflowWrap: "break-word", wordBreak: "break-word" }}
            >
              <div className="header-text">{title}</div>
              {description && (
                <span
                  className="desc-text"
                  style={{
                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                  }}   
                >
                  {description}
                </span>
              )}
            </div>
          </Box>
        </Box>
      </Grid>

      {/* Right side (Optional Select dropdown) */}
      <Grid item>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          {actionButton && actionButton}
          {selectOptions && (
            <Select
              placeholder="Navigate to…"
              styles={customSelectStyles}
              options={selectOptions}
              onChange={handleSelectChange}
              className="subheader-select"
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default PageHeader;
